import { Box, Button } from '@fullstory/components';
import { getOrgId } from '@fullstory/redux/modules/fullstory/selectors';
import { HOME_ROUTE, generateRoutePath, SPACE_ROUTE } from '@fullstory/routes';
import { useSelector } from 'react-redux';
import { useActiveSpaceContext } from '../../contexts';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { HOME_SPACE_ID } from '../../constants';
import { SpaceOwnership } from '../../hooks';

interface ReturnToSpaceButtonProps {
  objectSpaces?: SpaceOwnership | null;
}

export const ReturnToSpaceButton: React.FC<ReturnToSpaceButtonProps> = ({ objectSpaces }) => {
  const history = useHistory();
  const { activeSpace } = useActiveSpaceContext();
  const isLibraryTab = activeSpace?.tab === 'library';
  const orgId = useSelector(getOrgId);
  const location = useLocation<{ templateGalleryOpen?: boolean }>();
  if (
    !activeSpace?.space ||
    (objectSpaces?.space?.id === activeSpace.space.id && activeSpace.space.id !== HOME_SPACE_ID) ||
    (!objectSpaces?.referencedIn.find(s => s.id === activeSpace.space!.id) &&
      activeSpace.space.id !== HOME_SPACE_ID)
  )
    return null;

  // Returning undefined instead of empty params which results in adding an empty ? to the URL
  const homeParams = location.state?.templateGalleryOpen ? { templateGallery: true } : undefined;

  const path =
    activeSpace.space.id === 'home'
      ? generateRoutePath(HOME_ROUTE, { orgId }, homeParams)
      : generateRoutePath(
          SPACE_ROUTE,
          { orgId, id: activeSpace.space.id },
          {
            tab: isLibraryTab ? 'library' : 'home',
          },
        );

  return (
    <Box data-component="ReturnToSpaceButton" flexShrink={0}>
      <Button iconLeft="arrow-left" variant="fill-secondary" onClick={() => history.push(path)}>
        {activeSpace.space!.name}
      </Button>
    </Box>
  );
};
